import { Button } from "@heroui/react";
import clsx from "clsx";

export interface StepperNavigationButtonsProps {
  isDisabled?: boolean;
  isFirstStep: boolean;
  onNext: () => void;
  onPrevious: () => void;
  nextButtonLabel?: string;
  previousButtonLabel?: string;
  classNames?: string;
}

export function StepperNavigationButtons({
  isDisabled,
  isFirstStep,
  onNext,
  onPrevious,
  nextButtonLabel = "Next",
  previousButtonLabel = "Previous",
  classNames,
}: StepperNavigationButtonsProps) {
  const handlePrevious = () => {
    if (!isFirstStep) {
      onPrevious();
    }
  };

  return (
    <div className={clsx("mt-auto flex justify-between gap-3 pt-4", classNames)}>
      {!isFirstStep && (
        <Button
          onPress={handlePrevious}
          isDisabled={isFirstStep || isDisabled}
          variant="flat"
          aria-label="Go to previous step"
        >
          {previousButtonLabel}
        </Button>
      )}

      <Button className="ml-auto" isDisabled={isDisabled} onPress={onNext} color="primary" aria-label="Go to next step">
        {nextButtonLabel}
      </Button>
    </div>
  );
}
